import { render } from "./AboutM.vue?vue&type=template&id=7b325dfb&scoped=true"
import script from "./AboutM.vue?vue&type=script&lang=js"
export * from "./AboutM.vue?vue&type=script&lang=js"

import "./AboutM.vue?vue&type=style&index=0&id=7b325dfb&scoped=true&lang=css"

import exportComponent from "E:\\vueWeb\\official\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b325dfb"]])

export default __exports__